import { createContext, useContext } from 'react';

import { Course } from '~/models/Course';

const CourseContext = createContext<Course>(new Course());

export const useCourseContext = () => useContext(CourseContext);

export default CourseContext;
